import { render, staticRenderFns } from "./Mails.vue?vue&type=template&id=2d4ca0d8&"
import script from "./Mails.vue?vue&type=script&lang=js&"
export * from "./Mails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports